import { useEffect, useState } from 'react';
import { Input } from '../ui/input';
import { Label } from '../ui/label';

const ShowGreatGrandParents = ({ id, type,  }) => {
    const [data, setData] = useState({
        nom: '',
        prénom: '',
        naissance: '',
        lieu: ''
    });

    useEffect(() => {
        const nom = localStorage.getItem(`lastname${type}${id}`) || '';
        const prénom = localStorage.getItem(`firstname${type}${id}`) || '';
        const naissance = localStorage.getItem(`birthborn${type}${id}`) || '';
        const lieu = localStorage.getItem(`birthplace${type}${id}`) || '';

        setData({ nom, prénom, naissance, lieu });
    }, [id, type]);

    const isEmpty = !data.nom && !data.prénom && !data.naissance && !data.lieu;
    if (isEmpty) return null;

    return (
        <div className="max-w-md w-full">
            <div className='p-6 bg-white dark:bg-black flex justify-center'>
                <div className="w-full border border-gray-700 rounded-lg p-6 shadow-md dark:bg-neutral-900 bg-gray-100">
                    <p className='text-2xl font-bold text-black dark:text-white'>{data.nom} <br></br> {data.prénom}</p>
                    <p className='text-2xl font-bold text-black dark:text-white'>{data.naissance}</p>
                    <p className='text-2xl font-bold text-black dark:text-white'>{data.lieu}</p>
                </div>
            </div>
        </div>
    );
};
 
const GreatGrandFather = ({nom, prénom, id}) => {
    const [lastName, setLastName] = useState(() => localStorage.getItem(`lastnameggp${id}`) || '');
    const [firstName, setFirstName] = useState(() => localStorage.getItem(`firstnameggp${id}`) || '');
    // const [birthBorn, setBirthBorn] = useState(() => localStorage.getItem(`birthbornggp${id}`) || '');
    const [birthPlace, setBirthPlace] = useState(() => localStorage.getItem(`birthplaceggp${id}`) || '');
    const [suggestions, setSuggestions] = useState([]);
    const GEOAPIFY_API_KEY = 'b9fa4117852c4c3392e6356bffd5fda7';
    const [birthPlaceError, setBirthPlaceError] = useState('');

    const handleSelectCity = (city) => {
        setBirthPlace(city);
        setSuggestions([]);
        setBirthPlaceError('');
        localStorage.setItem(`birthplaceggp${id}`, city);
    };
 
    const handleChangeFirstName = (e) => {
        setFirstName(e.target.value)
        localStorage.setItem(`firstnameggp${id}`, e.target.value)
    }
 
    const handleChangeLastName = (e) => {
        const upperCaseValue = e.target.value.toUpperCase();
        setLastName(upperCaseValue);
        setTimeout(() => {
            localStorage.setItem(`lastnameggp${id}`, e.target.value)
        }, 100);
    }
 
    // const handleChangeBirthBorn = (e) => {
    //     let value = e.target.value;
  
    
    //     setBirthBorn(value);
    
    //     localStorage.setItem(`birthbornggp${id}`, e.target.value)
    // }
 
    const handleChangeBirthPlace = async (e) => {
        const value = e.target.value;
        setBirthPlace(value);
        localStorage.setItem(`birthplaceggp${id}`, value);
        if (value.length > 2) {
            try {
              const response = await fetch(
                `https://api.geoapify.com/v1/geocode/autocomplete?text=${encodeURIComponent(
                  value
                )}&type=city&limit=5&apiKey=${GEOAPIFY_API_KEY}`
              );
              const data = await response.json();
        
              if (data.features) {
                setSuggestions(
                  data.features.map((feature) => ({
                    name: feature.properties.city || feature.properties.name,
                    state: feature.properties.state || feature.properties.region,
                    country: feature.properties.country || feature.properties.country_code,
                  }))
                );
                setBirthPlaceError('');
              } else {
                setSuggestions([]);
              }
            } catch (error) {
              console.error('Erreur Geoapify :', error);
              setSuggestions([]);
            }
          } else {
            setSuggestions([]);
          }
    }
 
    useEffect(() => {
        const savedFirstName = localStorage.getItem(`firstnameggp${id}`)
        const savedLastName = localStorage.getItem(`lastnameggp${id}`)
        const savedBirthBorn = localStorage.getItem(`birthbornggp${id}`)
        const savedBirthPlace = localStorage.getItem(`birthplaceggp${id}`)
 
        if (savedLastName)
            console.log(savedLastName)
        if (savedFirstName)
            console.log(savedFirstName)
        if (savedBirthBorn)
            console.log(savedBirthBorn)
        if (savedBirthPlace)
            console.log(savedBirthPlace)
    })
 
    const fullName = prénom && nom ? `${prénom} ${nom}` : '';
 
    return (
        <form className='"mx-auto max-w-lg'>
            <div className='p-6 bg-white dark:bg-black flex justify-center'>
                <div className="w-full max-w-md rounded-lg p-6 shadow-md dark:bg-neutral-900 bg-gray-100">
                    <h1 className='text-black dark:text-white text-xl font-semibold mb-4'>Mettez le nom du père <br></br>de {prénom} {nom}</h1>
 
                    <div className='mb-4'>
                        <Label className='text-lg font-bold text-black dark:text-white' htmlFor="father-lastname">Nom du père <br></br> de {prénom} {nom}</Label>
                        <Input value={lastName} onChange={handleChangeLastName} type="text" className="w-full" id="father-lastname" placeholder={fullName ? `Entrez le nom du père de ${fullName}` : ''} />
                    </div>
 
                    <div className='mb-4'>
                        <Label className='text-lg font-bold text-black dark:text-white' htmlFor="father-firstname">Prénom du père <br></br> de {prénom} {nom}</Label>
                        <Input value={firstName} onChange={handleChangeFirstName} type="text" className="w-full" id="father-firstname" placeholder={fullName ? `Entrez le prénom du père de ${fullName}` : ''} />
                    </div>
 
                    {/* <div className='mb-4'>
                        <Label className='text-lg font-bold text-black dark:text-white' htmlFor="father-birthdate">Année de naissance <br></br>  du père de <br></br> {prénom} {nom}</Label>
                        <Input value={birthBorn} onChange={handleChangeBirthBorn} type="number" className={`w-full ${birthBornError ? "border-red-600" : ""}`} id="father-birthdate" placeholder={fullName ? `Entrez l'année de naissance du père de ${fullName}` : ''} />
                    </div> */}
 
                    <div className='mb-4'>
                        <Label className='text-lg font-bold text-black dark:text-white' htmlFor="father-birthplace">Lieu de naissance <br></br> du père de {prénom} {nom}</Label>
                        <Input value={birthPlace} onChange={handleChangeBirthPlace} type="text" className="w-full" id="father-birthplace" placeholder={fullName ? `Entrez le lieu de naissance du père de ${fullName}` : ''} />
                        {suggestions.length > 0 && (
                          <ul className="absolute z-10 bg-white border border-gray-300 w-full max-w-sm mt-1 rounded-md shadow-lg max-h-40 overflow-y-auto">
                            {suggestions
                            .filter(item => item.name && item.name.trim() !== '')
                            .map((item, idx) => (
                              <li
                                key={idx}
                                className="group relative overflow-hidden rounded-lg bg-gradient-to-r from-slate-800 to-slate-700 p-4 mb-2 shadow-lg border border-slate-600 hover:border-blue-400 cursor-pointer transition-all duration-300 ease-in-out hover:shadow-xl hover:scale-[1.02] hover:from-slate-700 hover:to-slate-600"
                                onClick={() => handleSelectCity(item.name)}
                              >
                                <div className="flex items-center justify-between">
                                  <div className="flex flex-col">
                                    <span className="font-semibold text-white text-lg group-hover:text-blue-300 transition-colors duration-200">
                                      {item.name}
                                    </span>
                                    <span className="text-slate-300 text-sm opacity-80 group-hover:opacity-100 transition-opacity duration-200">
                                      {item.state}, {item.country}
                                    </span>
                                  </div>
                                  <div className="opacity-0 group-hover:opacity-100 transition-opacity duration-200">
                                    <svg className="w-5 h-5 text-blue-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                                    </svg>
                                  </div>
                                </div>
                                
                                {/* Effet de brillance au survol */}
                                <div className="absolute inset-0 opacity-0 group-hover:opacity-20 bg-gradient-to-r from-transparent via-white to-transparent transform -skew-x-12 -translate-x-full group-hover:translate-x-full transition-transform duration-700 ease-in-out"></div>
                              </li>
                            ))}
                          </ul>
                        )}
                            {birthPlaceError && <p className="text-red-600 text-sm mt-1">{birthPlaceError}</p>}
                    </div>
                </div>
            </div>
        </form>
    )
}
 
const GreatGrandMother = ({ prénom, nom, id }) => {
    const [lastName, setLastName] = useState(() => localStorage.getItem(`lastnameggm${id}`) || '');
    const [firstName, setFirstName] = useState(() => localStorage.getItem(`firstnameggm${id}`) || '');
    // const [birthBorn, setBirthBorn] = useState(() => localStorage.getItem(`birthbornggm${id}`) || '');
    const [birthPlace, setBirthPlace] = useState(() => localStorage.getItem(`birthplaceggm${id}`) || '');
    // const [birthBornError, setBirthBornError] = useState('');
    const [suggestions, setSuggestions] = useState([]);
    const GEOAPIFY_API_KEY = 'b9fa4117852c4c3392e6356bffd5fda7';
    const [birthPlaceError, setBirthPlaceError] = useState('');

    const handleSelectCity = (city) => {
        setBirthPlace(city);
        setSuggestions([]);
        setBirthPlaceError('');
        localStorage.setItem(`birthplaceggm${id}`, city);
    };
 
    const handleChangeFirstName = (e) => {
        setFirstName(e.target.value)
        localStorage.setItem(`firstnameggm${id}`, e.target.value)
    }
 
    const handleChangeLastName = (e) => {
        const upperCaseValue = e.target.value.toUpperCase();
        setLastName(upperCaseValue);
        setTimeout(() => {
            localStorage.setItem(`lastnameggm${id}`, e.target.value)
        }, 100);
    }
 
    // const handleChangeBirthBorn = (e) => {
    //     let value = e.target.value;
  
    //     // Supprimer tous les caractères sauf les chiffres
    //     value = value.replace(/\D/g, '');
      
    //     // Insérer les slash automatiquement
    //     if (value.length > 2 && value.length <= 4) {
    //       value = value.slice(0, 2) + '/' + value.slice(2);
    //     } else if (value.length > 4) {
    //       value = value.slice(0, 2) + '/' + value.slice(2, 4) + '/' + value.slice(4, 8);
    //     }
      
    //     setBirthBorn(value);
      
    //     // Validation simple du format jj/mm/aaaa
    //     if (!/^(0[1-9]|[12]\d|3[01])\/(0[1-9]|1[0-2])\/\d{4}$/.test(value)) {
    //       setBirthBornError("Format date invalide, attendu jj/mm/aaaa");
    //     } else {
    //       setBirthBornError("");
    //     }
    //     localStorage.setItem(`birthbornggm${id}`, e.target.value)
    // }
 
    const handleChangeBirthPlace = async (e) => {
        const value = e.target.value;
        setBirthPlace(value);
        localStorage.setItem(`birthplaceggm${id}`, value);
        if (value.length > 2) {
            try {
              const response = await fetch(
                `https://api.geoapify.com/v1/geocode/autocomplete?text=${encodeURIComponent(
                  value
                )}&type=city&limit=5&apiKey=${GEOAPIFY_API_KEY}`
              );
              const data = await response.json();
        
              if (data.features) {
                setSuggestions(
                  data.features.map((feature) => ({
                    name: feature.properties.city || feature.properties.name,
                    state: feature.properties.state || feature.properties.region,
                    country: feature.properties.country || feature.properties.country_code,
                  }))
                );
                setBirthPlaceError('');
              } else {
                setSuggestions([]);
              }
            } catch (error) {
              console.error('Erreur Geoapify :', error);
              setSuggestions([]);
            }
          } else {
            setSuggestions([]);
          }
    }
 
    const fullName = prénom && nom ? `${prénom} ${nom}` : '';
 
    return (
        <form className='mx-auto max-w-sm'> {/* réduit max width ici */}
            <div className='p-6 bg-white dark:bg-black flex justify-center'> {/* p-6 au lieu de p-10 */}
                <div className="w-full max-w-md rounded-lg p-6 shadow-md dark:bg-neutral-900 bg-gray-100">
                    <h1 className='text-black dark:text-white text-lg font-semibold mb-4'>
                        Mettez le nom de jeune fille de la mère de {prénom} {nom}
                    </h1>
 
                    <div className='mb-4'>
                        <Label className='text-base font-bold text-black dark:text-white' htmlFor="mother-lastname">Nom de la mère de jeune fille <br></br> de {prénom} {nom}</Label>
                        <Input value={lastName} onChange={handleChangeLastName} type="text" id="mother-lastname" className="w-full" placeholder={fullName ? `Nom de la mère de ${fullName}` : ''} />
                    </div>
 
                    <div className='mb-4'>
                        <Label className='text-base font-bold text-black dark:text-white' htmlFor="mother-firstname">Prénom de la mère <br></br> de {prénom} {nom}</Label>
                        <Input value={firstName} onChange={handleChangeFirstName} type="text" id="mother-firstname" className="w-full" placeholder={fullName ? `Prénom de la mère de ${fullName}` : ''} />
                    </div>
 
                    {/* <div className='mb-4'>
                        <Label className='text-base font-bold text-black dark:text-white' htmlFor="mother-birthdate">Année de naissance de la mère de {prénom} {nom}</Label>
                        <Input value={birthBorn} onChange={handleChangeBirthBorn} type="text" id="mother-birthdate" className={`w-full ${birthBornError ? "border-red-600" : ""}`} placeholder={fullName ? `Entrez l'année de naissance de la mère de ${fullName}` : ''}/>
                        {birthBornError && <p className="text-red-600 text-sm mt-1">{birthBornError}</p>}
                    </div> */}
 
                    <div className='mb-4'>
                        <Label className='text-base font-bold text-black dark:text-white' htmlFor="mother-birthplace">Lieu de naissance de la mère de {prénom} {nom}</Label>
                        <Input value={birthPlace} onChange={handleChangeBirthPlace} type="text" id="mother-birthplace" className="w-full" placeholder={fullName ? `Lieu de naissance de la mère de ${fullName}` :  ''} />
                        {suggestions.length > 0 && (
                                <ul className="absolute z-10 bg-white border border-gray-300 w-full max-w-sm mt-1 rounded-md shadow-lg max-h-40 overflow-y-auto">
                                  {suggestions
                                  .filter(item => item.name && item.name.trim() !== '')
                                  .map((item, idx) => (
                                    <li
                                      key={idx}
                                      className="group relative overflow-hidden rounded-lg bg-gradient-to-r from-slate-800 to-slate-700 p-4 mb-2 shadow-lg border border-slate-600 hover:border-blue-400 cursor-pointer transition-all duration-300 ease-in-out hover:shadow-xl hover:scale-[1.02] hover:from-slate-700 hover:to-slate-600"
                                      onClick={() => handleSelectCity(item.name)}
                                    >
                                      <div className="flex items-center justify-between">
                                        <div className="flex flex-col">
                                          <span className="font-semibold text-white text-lg group-hover:text-blue-300 transition-colors duration-200">
                                            {item.name}
                                          </span>
                                          <span className="text-slate-300 text-sm opacity-80 group-hover:opacity-100 transition-opacity duration-200">
                                            {item.state}, {item.country}
                                          </span>
                                        </div>
                                        <div className="opacity-0 group-hover:opacity-100 transition-opacity duration-200">
                                          <svg className="w-5 h-5 text-blue-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                                          </svg>
                                        </div>
                                      </div>
                                      
                                      {/* Effet de brillance au survol */}
                                      <div className="absolute inset-0 opacity-0 group-hover:opacity-20 bg-gradient-to-r from-transparent via-white to-transparent transform -skew-x-12 -translate-x-full group-hover:translate-x-full transition-transform duration-700 ease-in-out"></div>
                                    </li>
                                  ))}
                                </ul>
                              )}
                            {birthPlaceError && <p className="text-red-600 text-sm mt-1">{birthPlaceError}</p>}

                    </div>
                </div>
            </div>
        </form>
    );
};
 
const GreatGrandParentsBranch = ({setShowGrandParents, setShowDataGrandParents, setShowGPP}) => {
    const [showGreatGrandParents, setShowGreatGrandParents] = useState(true)
    const [showDataGreatGrandParents, setShowDataGreatGrandParents] = useState(false)
    const greatFatherFirstname1 = localStorage.getItem('firstnamegp1')
    const greatFatherLastname1 = localStorage.getItem('lastnamegp1')
    const greatMotherFirstname1 = localStorage.getItem('firstnamegm2')
    const greatMotherLastname1 = localStorage.getItem('lastnamegm2')
    const greatFatherFirstname2 = localStorage.getItem('firstnamegp3')
    const greatFatherLastname2 = localStorage.getItem('lastnamegp3')
    const greatMotherFirstname2 = localStorage.getItem('firstnamegm4')
    const greatMotherLastname2 = localStorage.getItem('lastnamegm4')
    const [showModal, setShowModal] = useState(false)
 
    const handleSubmitDataGrandParents = (e) => {
        setShowGreatGrandParents(false)
        setShowDataGreatGrandParents(true)
        setShowModal(true)
 
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    }
    return (
        <div>
            {showGreatGrandParents &&
                <div className="flex flex-col items-center justify-center p-10">
                    <div className="flex flex-wrap justify-center max-w-[1800px] mx-auto">
                        {greatFatherFirstname1 && greatFatherLastname1 && (
                            <div>
                                <GreatGrandFather prénom={greatFatherFirstname1} nom={greatFatherLastname1} id="1" />
                                <GreatGrandMother prénom={greatFatherFirstname1} nom={greatFatherLastname1} id="2" />
                            </div>
                        )}
 
                        {greatMotherFirstname1 && greatMotherLastname1 && (
                            <div>
                                <GreatGrandFather prénom={greatMotherFirstname1} nom={greatMotherLastname1} id="3" />
                                <GreatGrandMother prénom={greatMotherFirstname1} nom={greatMotherLastname1} id="4" />
                            </div>
                        )}
 
                        {greatFatherFirstname2 && greatFatherLastname2 && (
                            <div>
                                <GreatGrandFather prénom={greatFatherFirstname2} nom={greatFatherLastname2} id="5" />
                                <GreatGrandMother prénom={greatFatherFirstname2} nom={greatFatherLastname2} id="6" />
                            </div>
                        )}
 
                        {greatMotherFirstname2 && greatMotherLastname2 && (
                            <div>
                                <GreatGrandFather prénom={greatMotherFirstname2} nom={greatMotherLastname2} id="7" />
                                <GreatGrandMother prénom={greatMotherFirstname2} nom={greatMotherLastname2} id="8" />
                            </div>
                        )}
                    </div>
                    {/* Buttons */}
                    <div className="flex flex-col sm:flex-row mt-4">
                        <button
                            type="button"
                            onClick={() => {
                                setShowDataGrandParents(false)
                                setShowGPP(false)
                                setShowGrandParents(true)
                            }}
                            className="py-4 px-8 text-xl font-bold rounded-xl border border-transparent bg-blue-100 text-blue-800 hover:bg-blue-200 dark:text-blue-400 dark:bg-blue-800/30 dark:hover:bg-blue-800/20"
                        >
                            Revenez sur le formulaire précédent
                        </button>
                        <button
                            type="button"
                            onClick={handleSubmitDataGrandParents}
                            className="py-4 px-8 text-xl font-bold rounded-xl border border-transparent bg-green-100 text-green-800 hover:bg-green-200 dark:text-green-400 dark:bg-green-800/30 dark:hover:bg-green-800/20"
                        >
                            Continuer votre arbre
                        </button>
                    </div>
                </div>
            }
            {showDataGreatGrandParents &&
                <div>
                    <div className="flex flex-col md:flex-row items-center justify-center">
                        <div className="w-full md:w-1/2">
                            <ShowGreatGrandParents id="1" type="ggp" />
                            <ShowGreatGrandParents id="2" type="ggm" />
                        </div>
                        <div className="w-full md:w-1/2">
                            <ShowGreatGrandParents id="3" type="ggp" />
                            <ShowGreatGrandParents id="4" type="ggm" />
                        </div>
                        <div className="w-full md:w-1/2">
                            <ShowGreatGrandParents id="5" type="ggp" />
                            <ShowGreatGrandParents id="6" type="ggm" />
                        </div>
                        <div className="w-full md:w-1/2">
                            <ShowGreatGrandParents id="7" type="ggp" />
                            <ShowGreatGrandParents id="8" type="ggm" />
                        </div>
                    </div>
                    {showModal && (
                        <div className="fixed inset-0 flex items-center justify-center z-50 bg-opacity-50 bg-gray-700">
                            <div className="bg-white dark:bg-neutral-900 p-6 rounded-lg shadow-lg w-96 text-center">
                                <h2 className="text-xl font-semibold mb-4 dark:text-white text-black"> Veuillez confirmer que les informations des arrière-grands-parents sont exactes.</h2>
                                <div className="flex justify-between">
                                    <button
                                        onClick={() =>  {
                                            setShowGreatGrandParents(true)
                                            setShowDataGreatGrandParents(false)
                                            setShowModal(false)
                                        }
                                        }
                                        className="py-2 px-4 bg-gray-300 rounded-lg hover:bg-gray-400"
                                    >
                                        Annuler
                                    </button>
                                    <button
                                        onClick={() => {
                                            setShowModal(false)
                                        }}
                                        className="py-2 px-4 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
                                    >
                                        Confirmer
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            }
        </div>
    )
}
 
export default GreatGrandParentsBranch